'use strict';

define('app/setup/registerComponentsFromConfig',['knockout'], function (ko) {

	return function registerComponentsFromConfig(componentConfiguration) {

		componentConfiguration.forEach(function (component) {
			if (!ko.components.isRegistered(component.name)) {
				ko.components.register(component.name, component.config);
			}
		});
	};
});
